import { AsyncJobType } from '@recruitee/account/data';

export enum AsyncJobStatus {
  IDLE = 'idle',
  START = 'start',
  WORKING = 'working',
  FINISHED = 'finished',
}

export interface AsyncJob {
  uuid: string;
  type: AsyncJobType;
  count: number;
  total: number;
  payload?: any;

  errors: any[];
  status: AsyncJobStatus;
}
